import { Store } from 'pullstate'

export const DashboardStore = new Store({
  dashboardList: []
})
